import React from 'react';
import cn from 'classnames';
import styles from './PageToolbar.module.scss';

type PageToolbarProps = {
  children: React.ReactNode;
  leading?: React.ReactNode;
  className?: string;
};

/** Keeps existing page actions in a predictable, responsive position. */
const PageToolbar = ({
  children,
  leading,
  className,
}: PageToolbarProps): JSX.Element => (
  <div className={cn(styles.toolbar, className)} aria-label="Page actions">
    {leading && <div className={styles.leading}>{leading}</div>}
    <div className={styles.actions}>{children}</div>
  </div>
);

export default PageToolbar;
